import styled from 'styled-components';
import Inner from '../components/Inner';
import PageTitle from '../components/PageTitle';
import GoodsCard from '../components/GoodsCard';
import goods from '../mock/goods.json';

const CardContainer = styled.div`
	width: 100%;
	margin: 0 auto 9rem;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;

	@media (max-width: 767px) {
		margin: 0 auto 5.5rem;
	}

	@media (min-width: 768px) and (max-width: 1023px) {
		margin: 0 auto 7rem;
	}
`;

function Goods() {
	return (
		<Inner>
			<PageTitle>Goods</PageTitle>
			<CardContainer>
				{goods.map((product) => {
					return (
						<GoodsCard
							key={product.id}
							id={product.id}
							img={product.img}
							title={product.title}
							artist={product.artist}
							price={product.price}
						/>
					);
				})}
			</CardContainer>
		</Inner>
	);
}

export default Goods;
